<template>
    <el-autocomplete
        size="small"
        v-model="flowIds"
        :fetch-suggestions="querySearchAsync"
        :disabled="disable"
        placeholder="请输入流程名称"
        @select="handleChange"
        style="width: 250px"
        @blur="handleBlur">
        <template slot-scope="{ item }">
            <div class="label" :title="item.value" >{{ item.value }}</div>
        </template>
    </el-autocomplete>

</template>


<script>
    import FlowService from "~/services/flow";

export default {
    name: "FlowSelect",

    props: {
        flowIdss:'',
        placeholder:{
          required:false,
          default:'请输入关键词'
        },
        activeTab:{
            type: String,
            default: ''
        },
        isOrder:{
            type: Number,
            default: 0
        },
        // customerId: "",
        //isMultiple: true,
        onlyShow: false, //true:只做展示不可搜索 例如联系人编辑，就是只做展示的
        scenary:false,//场景值，部分场景不需要查找出全部客户，比如创建订单的时候，只需要查找出与业务员绑定的客户
    },
    data() {
        return {
            //定义变量
            //loading: true,
            flowIds: null,
            //list: [],
            //isMany: true, //是否支持多个, 此处为了兼容外部传入组件内的值类型错误问题
            disable:false,   //禁止选择
          //  activeTab:''
        };
    },

    created: function() {
        if(typeof this.permissionIds != 'undefined'){
            this.flowIds = this.flowIdss;
        }
        if (this.onlyShow) {
            this.disable = true;
        } else {
            this.disable = false;
        }
    },
    methods: {
        querySearchAsync(queryString, cb) {
            let qs = (queryString || '').toString().trim() || undefined;
            let params = {
              //  fields: 'id,name',
                isNotRed:1,
                name: qs,
                scenary:this.scenary,
                order_type: 0
            };
            if(this.activeTab == 'trial') {
                params.order_type = 1;
            }
            if(this.isOrder == 1) {
                //加载订单流程列表
                FlowService.getOrderFlow(params).then(res => {
                    if (!res.data) return;
                    let results = res.data.filter(item => {
                        if (!qs) return true;
                        return item.desc.toString().indexOf(qs)> -1;
                    }).map( item => {
                        return {
                            value: item.desc,
                            label: item.id
                        };
                    });
                    cb(results)
                });
            }else{
                FlowService.getList(params).then(res => {
                    if (!res.data) return;
                    let results = res.data.filter(item => {
                        if (!qs) return true;
                        return item.name.toString().indexOf(qs)> -1;
                    }).map( item => {
                        return {
                            value: item.name,
                            label: item.id
                        };
                    });
                    cb(results)
                });
            }
        },

        //select value值变化时触发
        handleChange(item) {
            this.$emit("change", item); 
        },

        handleBlur($event) {
            this.$emit("change", $event.target);
        },
        //对输入框进行重置     
        reset(){
            this.flowIds = '';
        }           
    }
}



</script>


// WEBPACK FOOTER //
// src/widgets/FlowSelect.vue